import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        login: false,
        custId: "",
        ticketFields: [],
        signature: "",
        udeskList: [],
        udeskSub: [],
        userName: '',
        ticketPlugin: [],
        TicketFieldsLang: [],
        userToken: "",
        udeskListCount: "",
        ticket: {},
        captcha: {
            key: '',
            url: '',
        },
        class: '',
        topAlert: '',
        InformationTwo: '',
        InformationOne: '',
        avatarUrl: "",
    },
    mutations: {
        //工单填写custid 暂时存储
        SaveTicket(state, value) {
            state.ticket = {}
            state.ticket = value
        },
        GetTicketPlugin(state, value) {
            state.ticketPlugin = value
        },
        SaveToken(state, value) {
            state.userToken = value
        },
        SaveCaptcha(state, value) {
            state.captcha.key = value.key
            state.captcha.url = value.url
        },
        SaveInformationOne(state, value) {
            state.InformationOne = value
        },
        SaveInformationTwo(state, value) {
            state.InformationTwo = value
        },
        SaveClass(state, value) {
            state.class = value
        },
        SaveTopAlert(state, value) {
            state.topAlert = value
        },
        LOGIN(state, value) {
            state.login = true;
            console.log(state);
            state.custId = value.custId;
            state.userName = value.displayName;
            state.signature = value.signature;
            state.avatarUrl = value.avatarUrl;

            function getCookie(name) {
                var strcookie = document.cookie; //获取cookie字符串
                var arrcookie = strcookie.split("; "); //分割
                //遍历匹配
                for (var i = 0; i < arrcookie.length; i++) {
                    var arr = arrcookie[i].split("=");
                    if (arr[0] == name) {
                        return arr[1];
                    }
                }
                return "";
            }
            if (value.signature != '') {
                if (getCookie('bindId').indexOf(value.signature) == -1) {
                    document.cookie = "bindId=" + getCookie('bindId') + value.signature + ';path = /';
                    if (getCookie('cust_id_game') == '') {
                        window.location.href = '/bind'
                    }
                }
            }


        },
        SetListSub(state, value) {
            state.udeskSub = value;
        },
        SetListSub(state, value) {
            state.udeskSub = value;
        },
        // HasLogin(state, value) {
        //     if (value.value) {
        //         this.$route.push("/login")
        //     }
        // },
        ClearUdeskList(state, value) {
            state.udeskList = [];
        },
        SaveTicketFields(state, value) {
            state.TicketFieldsLang = value;
        },
        SaveUdeskList(state, value) {
            state.udeskList = value.tickets;
            state.udeskListCount = Math.ceil(value.meta.count / 10);
        },

        GetTicketFields(state, value) {
            state.ticketFields = value
            console.log(state);
        },
        Logout(state) {
            console.log(state);
            state.login = false;
            localStorage.setItem('result_code', '');

            state.custId = "";

        },
    },
    actions: {},
    modules: {}
})